export const ENV = {
   firebase: {
      apiKey: "AIzaSyDLQlIV3Yp-2o9yyumPQ_3BW_irMBfyGpQ",
      authDomain: "nasa-space-challenge.firebaseapp.com",
      databaseURL: "https://nasa-space-challenge.firebaseio.com",
      projectId: "nasa- space-challenge",
      storageBucket: "nasa-space-challenge.appspot.com",
      messagingSenderId: "889701386576",
      appId: "1:889701386576:web:54bdbc29f3ab87abc2c455",
      measurementId: "G-R3WTM2488Z"
   },
   googleMapsApiKey: "AIzaSyCFiqpUcIEZIEF4bqhVgL1xOqBW706h2bk",
   regex: {
      // nome: /.*/,
      // idade: /.*/,
      // observacoes: /.*/
   },
   production: false
}


// WEBPACK FOOTER //
// ./src/app/environment.ts